import { render, staticRenderFns } from "./CurrentRound.vue?vue&type=template&id=5be97eae&scoped=true&"
import script from "./CurrentRound.vue?vue&type=script&lang=js&"
export * from "./CurrentRound.vue?vue&type=script&lang=js&"
import style0 from "./CurrentRound.vue?vue&type=style&index=0&id=5be97eae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be97eae",
  null
  
)

export default component.exports